var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Core, Breadcrumb } from '@heimdallr-sdk/core';
import { PlatformTypes, BrowserReportType } from '@heimdallr-sdk/types';
import { formatDate, generateUUID, beacon, get, imgRequest, post } from '@heimdallr-sdk/utils';
import { nextTick } from './lib/nextTick';
import jsErrorPlugin from './plugins/jsError';
import promiseErrorPlugin from './plugins/promiseError';
import lifeCyclePlugin from './plugins/lifeCycle';
var BrowserClient = (function (_super) {
    __extends(BrowserClient, _super);
    function BrowserClient(options) {
        var _this = _super.call(this, options) || this;
        _this.breadcrumb = new Breadcrumb(options);
        return _this;
    }
    BrowserClient.prototype.initAPP = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, initUrl, app, ctime, params, data, _b, id;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this.context, initUrl = _a.initUrl, app = _a.app || {};
                        ctime = formatDate();
                        params = __assign(__assign({ id: generateUUID() }, app), { ctime: ctime });
                        return [4, {data: {id: app.app_id}}];
                    case 1:
                        data = (_c.sent()).data;
                        _b = (data || {}).id, id = _b === void 0 ? '' : _b;
                        return [2, id];
                }
            });
        });
    };
    BrowserClient.prototype.isRightEnv = function () {
        return typeof window !== 'undefined';
    };
    BrowserClient.prototype.report = function (url, data, type) {
        if (type === void 0) { type = BrowserReportType.BEACON; }
        if (type === BrowserReportType.BEACON && navigator.sendBeacon) {
            beacon(url, data);
            return;
        }
        if (type === BrowserReportType.IMG || !navigator.sendBeacon) {
            imgRequest(url, data);
            return;
        }
        if (type === BrowserReportType.POST) {
            post(url, data);
            return;
        }
        return get(url, data);
    };
    BrowserClient.prototype.transform = function (datas) {
        if (!datas) {
            return null;
        }
        var userAgent = navigator.userAgent, language = navigator.language;
        var title = document.title;
        var href = location.href;
        return __assign({ session_id: this.sessionID, platform: PlatformTypes.BROWSER, page_title: title, path: href, language: language, user_agent: userAgent }, datas);
    };
    BrowserClient.prototype.nextTick = function (cb, ctx) {
        var args = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            args[_i - 2] = arguments[_i];
        }
        return nextTick.apply(void 0, __spreadArray([cb, ctx], args, false));
    };
    return BrowserClient;
}(Core));
var init = function (options) {
    var client = new BrowserClient(options);
    var _a = options.plugins, plugins = _a === void 0 ? [] : _a;
    client.use(__spreadArray([jsErrorPlugin, promiseErrorPlugin, lifeCyclePlugin], plugins, true));
};
export default init;
